var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChatsTeardrop = function SvgIconChatsTeardrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.25,
    d: "M8.634 16.5A6.75 6.75 0 0 0 15 21h6.188a.56.56 0 0 0 .562-.562V14.25a6.74 6.74 0 0 0-6.384-6.74M9 16.5H2.813a.563.563 0 0 1-.563-.562V9.75A6.75 6.75 0 1 1 9 16.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 4.125A5.625 5.625 0 0 0 3.375 9.75v5.625H9a5.625 5.625 0 1 0 0-11.25m7.154 2.334A7.873 7.873 0 0 0 3.432 4.182 7.88 7.88 0 0 0 1.125 9.75v6.188a1.687 1.687 0 0 0 1.688 1.687h5.07a7.88 7.88 0 0 0 7.117 4.5h6.188a1.687 1.687 0 0 0 1.687-1.687V14.25a7.866 7.866 0 0 0-6.72-7.791m.678 2.47q.043.408.043.821a7.875 7.875 0 0 1-6.469 7.749A5.62 5.62 0 0 0 15 19.875h5.625v-5.627a5.62 5.62 0 0 0-3.793-5.319",
    clipRule: "evenodd"
  })));
};
export default SvgIconChatsTeardrop;